<form
  class="update-record-dialog"
  [formGroup]="technicalForm"
  (ngSubmit)="onSubmit()"
>
  <section class="record-summary" aria-label="Technical record context">
    <div class="record-summary__icon" aria-hidden="true">
      <i class="pi pi-wrench"></i>
    </div>

    <div class="record-summary__copy">
      <span class="record-summary__eyebrow">Technical Record</span>
      <h2>{{ data.vehicle_reference || "Selected vehicle" }}</h2>
      <div class="record-summary__meta">
        <span>Vehicle ID: {{ data.vehicle_id }}</span>
        <span>Chassis: {{ data.chassis_no || "Not captured" }}</span>
      </div>
    </div>
  </section>

  <section class="form-section">
    <div class="form-section__header">
      <h3>Record details</h3>
    </div>

    <div class="form-grid">
      <div class="form-field">
        <label for="dateCompleted">Date Completed</label>
        <p-calendar
          inputId="dateCompleted"
          dateFormat="yy-mm-dd"
          dataType="string"
          [inline]="false"
          [touchUI]="true"
          appendTo="body"
          styleClass="w-full"
          formControlName="date_completed"
        ></p-calendar>
      </div>

      <div class="form-field">
        <label for="odometer">Odometer</label>
        <input
          id="odometer"
          formControlName="odometer"
          pInputText
          type="number"
          class="w-full"
        />
      </div>

      <div class="form-field form-field--wide">
        <label for="recordType">Record Type</label>
        <p-dropdown
          inputId="recordType"
          formControlName="record_type"
          placeholder="Select Record Type"
          appendTo="body"
          [options]="record_types"
          optionLabel="name"
          optionValue="value"
          (onChange)="onChange($event)"
          styleClass="w-full"
        ></p-dropdown>
      </div>
    </div>
  </section>

  <section
    class="form-section"
    *ngIf="technicalForm.get('record_type')?.value === 'brakes'"
  >
    <div class="form-section__header">
      <h3>Brake details</h3>
    </div>

    <div class="form-field">
      <label for="brakeRemarks">Remarks</label>
      <input
        id="brakeRemarks"
        formControlName="remarks"
        pInputText
        type="text"
        class="w-full"
      />
    </div>
  </section>

  <section
    class="form-section"
    *ngIf="technicalForm.get('record_type')?.value === 'service'"
  >
    <div class="form-section__header">
      <h3>Service details</h3>
    </div>

    <div class="form-grid">
      <div class="form-field">
        <label for="serviceType">Service Type</label>
        <input
          id="serviceType"
          formControlName="service_type"
          pInputText
          type="text"
          class="w-full"
        />
      </div>

      <div class="form-field">
        <label for="serviceJobNo">Service Job Number</label>
        <input
          id="serviceJobNo"
          formControlName="service_jobno"
          pInputText
          type="text"
          class="w-full"
        />
      </div>

      <div class="form-field">
        <label for="serviceBrakes">Brakes %</label>
        <input
          id="serviceBrakes"
          formControlName="service_brakes"
          pInputText
          type="number"
          class="w-full"
        />
      </div>
    </div>
  </section>

  <section
    class="form-section"
    *ngIf="technicalForm.get('record_type')?.value === 'tyres'"
  >
    <div class="form-section__header">
      <h3>Tyre details</h3>
    </div>

    <div class="form-grid">
      <div class="form-field">
        <label for="tyreSize">Tyre Size</label>
        <input
          id="tyreSize"
          formControlName="tyre_size"
          pInputText
          type="text"
          class="w-full"
        />
      </div>

      <div class="form-field">
        <label for="tyreType">Tyre Type</label>
        <input
          id="tyreType"
          formControlName="tyre_type"
          pInputText
          type="text"
          class="w-full"
        />
      </div>

      <div class="form-field">
        <label for="tyrePos">Tyre Pos</label>
        <input
          id="tyrePos"
          formControlName="tyre_pos"
          pInputText
          type="text"
          class="w-full"
        />
      </div>

      <div class="form-field">
        <label for="tyreRemarks">Remarks</label>
        <input
          id="tyreRemarks"
          formControlName="remarks"
          pInputText
          type="text"
          class="w-full"
        />
      </div>
    </div>
  </section>

  <section
    class="form-section"
    *ngIf="technicalForm.get('record_type')?.value"
  >
    <div class="form-section__header">
      <div>
        <h3>Jobs</h3>
        <span>{{ technicalJobArray.length }} linked</span>
      </div>

      <button
        pButton
        type="button"
        icon="pi pi-plus"
        label="Add job"
        class="p-button-sm p-button-outlined"
        (click)="addOrder()"
      ></button>
    </div>

    <div class="jobs-list" *ngIf="technicalJobArray.length; else noJobs">
      <article
        class="job-card"
        *ngFor="let job of technicalJobArray.controls; index as i"
      >
        <div class="job-card__header">
          <span>Job {{ i + 1 }}</span>

          <button
            pButton
            type="button"
            icon="pi pi-trash"
            label="Remove job"
            class="p-button-sm p-button-text p-button-danger"
            (click)="deleteOrder(i)"
          ></button>
        </div>

        <app-job-form
          [inputFormGroup]="$any(job)"
          [data]="data.technical_record_jobs[i]"
        ></app-job-form>
      </article>
    </div>

    <ng-template #noJobs>
      <div class="jobs-empty">
        <span>No jobs linked</span>
      </div>
    </ng-template>
  </section>

  <div class="dialog-actions">
    <button
      pButton
      type="submit"
      label="Save Technical Record"
      icon="pi pi-check"
      class="p-button-primary w-full"
      [loading]="loading"
    ></button>
  </div>
</form>
